interface ChartworkProps {
  onNavigate: (to: string) => void;
}

interface GameEntry {
  slug: string;
  name: string;
  blurb: string;
  ready: boolean;
}

const GAMES: readonly GameEntry[] = [
  {
    slug: "flashcards",
    name: "Identify the symbol",
    blurb:
      "See a chartwork symbol, pick what it means. Drills the RYA Day Skipper / Yachtmaster chartwork conventions — DR, EP, CTS, water track, ground track, tidal vector.",
    ready: true,
  },
  {
    slug: "compass",
    name: "Compass ⇄ True converter",
    blurb:
      "Convert between compass, magnetic and true headings applying variation and deviation. Both directions; the CADET working is shown on every answer.",
    ready: true,
  },
  {
    slug: "signs",
    name: "East / West sign drill",
    blurb:
      "Quick-fire on the sign rule — add or subtract? compass least or best? Trains CADET and “Error East, Compass Least” until it's automatic.",
    ready: true,
  },
  {
    slug: "cts",
    name: "Course to steer",
    blurb:
      "Work the tidal triangle: given the ground track, boat speed and tidal stream, pick the course to steer. Each answer shows the offset and resulting speed over the ground.",
    ready: true,
  },
  {
    slug: "deviation",
    name: "Deviation card lookup",
    blurb:
      "Read the deviation off the card for your heading, then apply it to find the magnetic heading. Drills the bit students forget — deviation changes with heading.",
    ready: true,
  },
  {
    slug: "ep",
    name: "Estimated position",
    blurb:
      "Plot the water track and tidal stream, then read off the course made good. Pick Simple (DR + tide) or Advanced (allow for leeway). Reveals the EP, distance made good and speed over the ground.",
    ready: true,
  },
  {
    slug: "dst",
    name: "Distance · Speed · Time",
    blurb:
      "Quick-fire on the D = S × T triangle — how far, how fast, how long. The bread-and-butter mental arithmetic of passage planning.",
    ready: true,
  },
];

export function Chartwork({ onNavigate }: ChartworkProps) {
  return (
    <>
      <p className="muted">
        Two parts to chartwork: the <strong>techniques</strong> you
        perform on the chart (DR, EP, CTS), and the{" "}
        <strong>symbols</strong> they leave behind. In our diagrams we
        colour-code the tracks so they're easy to tell apart at a
        glance — <span style={{ color: "#d97706", fontWeight: 600 }}>
          orange
        </span>{" "}for the water track / DR,{" "}
        <span style={{ color: "#b8307a", fontWeight: 600 }}>magenta</span>{" "}
        for the EP / ground track,{" "}
        <span style={{ color: "#1e6091", fontWeight: 600 }}>blue</span>{" "}
        for the tidal stream. On the chart in front of you a sharp
        pencil is fine; what matters is the <em>symbol</em> (half-arrow
        on the water track, triangle on a fix, three arrows on the
        tide), not the colour you draw it in. The full technique
        walkthroughs and symbol catalogue live on the Reference tab; drill
        recognition and compass-error conversion below. The Reference tab's{" "}
        <strong>Compass error</strong> section has the CADET diagram and a
        conversion calculator.
      </p>

      <h2 style={{ marginTop: 24 }}>Games</h2>
      {GAMES.map((g) => (
        <div key={g.slug} className="card">
          <h3 style={{ marginBottom: 4 }}>{g.name}</h3>
          <p className="small muted" style={{ marginBottom: 12 }}>
            {g.blurb}
          </p>
          <button
            onClick={() => onNavigate(`/play/chartwork/${g.slug}`)}
            className="secondary"
          >
            Play
          </button>
        </div>
      ))}

      <button className="secondary" onClick={() => onNavigate("/play")}>
        ← Back to Play
      </button>
    </>
  );
}
